class ToastService {
    private static instance: ToastService;
    private toastContainer: HTMLElement | null = null;
    private toastId = 0;
  
    static getInstance(): ToastService {
      if (!ToastService.instance) {
        ToastService.instance = new ToastService();
      }
      return ToastService.instance;
    }
  
    init() {
      if (!this.toastContainer) {
        this.toastContainer = document.createElement('div');
        this.toastContainer.className = 'global-toast-container';
        this.toastContainer.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          gap: 12px;
          max-width: 400px;
          pointer-events: none;
        `;
        document.body.appendChild(this.toastContainer);
      }
    }
  
    showSuccess(message: string, duration = 4000) {
      this.showToast('success', 'Success', message, duration);
    }
  
    showError(message: string, duration = 6000) {
      this.showToast('error', 'Error', message, duration);
    }
  
    private showToast(type: 'success' | 'error', title: string, message: string, duration: number) {
      this.init();
      const id = ++this.toastId;
      
      const toast = document.createElement('div');
      toast.className = `toast-message ${type}`;
      toast.style.cssText = `
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(12px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        min-width: 320px;
        max-width: 400px;
        pointer-events: auto;
        transform: translateX(400px);
        opacity: 0;
        transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        background: ${type === 'success' ? 
          'linear-gradient(135deg, rgba(34, 197, 94, 0.95), rgba(22, 163, 74, 0.9))' :
          'linear-gradient(135deg, rgba(239, 68, 68, 0.95), rgba(220, 38, 38, 0.9))'};
        color: white;
      `;
  
      toast.innerHTML = `
        <div style="flex-shrink: 0; width: 20px; height: 20px; margin-top: 2px;">
          ${type === 'success' ? 
            '<svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>' :
            '<svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L10 11.414l1.293-1.293a1 1 0 001.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>'
          }
        </div>
        <div style="flex: 1; min-width: 0;">
          <div style="font-size: 0.9rem; font-weight: 700; margin-bottom: 4px; line-height: 1.2;">${title}</div>
          <div style="font-size: 0.85rem; font-weight: 500; line-height: 1.4; opacity: 0.95; word-wrap: break-word;">${message}</div>
        </div>
      `;
  
      this.toastContainer!.appendChild(toast);
  
      // Animate in
      setTimeout(() => {
        toast.style.transform = 'translateX(0)';
        toast.style.opacity = '1';
      }, 10);
  
      // Auto remove
      setTimeout(() => {
        toast.style.transform = 'translateX(400px)';
        toast.style.opacity = '0';
        setTimeout(() => {
          if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        }, 300);
      }, duration);
    }
  }
  
  export const toastService = ToastService.getInstance();